import React, { useState } from "react";
import {
  FaCube,
  FaPaintBrush,
  FaMousePointer,
  FaDesktop,
  FaCode,
  FaMobileAlt,
  FaVideo,
  FaSearch,
  FaBullhorn,
  FaImages,
} from "react-icons/fa";

const OurServices = () => {
  const [expandedStates, setExpandedStates] = useState(Array(9).fill(false));

  const toggleExpanded = (index) => {
    const newStates = [...expandedStates];
    newStates[index] = !newStates[index];
    setExpandedStates(newStates);
  };

  const getIconForService = (id) => {
    switch (id) {
      case 0: return <FaPaintBrush size={30} color="#ff8f26" />;
      case 1: return <FaMousePointer size={30} color="#ff8f26" />;
      case 2: return <FaDesktop size={30} color="#ff8f26" />;
      case 3: return <FaCode size={30} color="#ff8f26" />;
      case 4: return <FaMobileAlt size={30} color="#ff8f26" />;
      case 5: return <FaVideo size={30} color="#ff8f26" />;
      case 6: return <FaSearch size={30} color="#ff8f26" />;
      case 7: return <FaBullhorn size={30} color="#ff8f26" />;
      case 8: return <FaImages size={30} color="#ff8f26" />;
      default: return <FaCube size={30} color="#ff8f26" />;
    }
  };

  const getFirstSentence = (text) => {
    const match = text.match(/^[^.!?]+[.!?]/);
    return match ? match[0] : text.substring(0, 100) + "...";
  };

  const services = [
    {
      id: 0,
      title: "Graphic Design & Branding",
      category: "graphic",
      description:
        "We create impactful visual identities that capture the essence of your brand.",
      longDescription:
        "Our graphic solutions enhance brand recognition and help businesses build trust through consistent visuals across all platforms. Whether it's marketing materials, corporate stationery, or digital assets, we deliver designs that resonate with your audience.",
      servicesList: [
        "Social media content design",
        "Marketing materials & company profiles",
        "Logos, brand identity, stationery",
        "Packaging design",
      ],
    },
    {
      id: 1,
      title: "UI/UX Design",
      category: "graphic",
      description:
        "Our UI/UX design services focus on creating intuitive, engaging, and user-centered digital experiences.",
      longDescription:
        "From wireframes to high-fidelity prototypes, we ensure every element contributes to a seamless and meaningful interaction. Our goal is to help businesses deliver superior digital experiences that improve user satisfaction and drive conversions.",
      servicesList: [
        "Web & mobile app UI design",
        "User research & personas",
        "Wireframes & prototypes",
        "Design systems and UI kits",
      ],
    },
    {
      id: 2,
      title: "Web Design & Frontend Development",
      category: "web",
      description:
        "We build modern, responsive, and performance-driven websites using the latest technologies and design standards.",
      longDescription:
        "Whether you need a corporate website, portfolio, or landing page, we deliver clean front-end development with pixel-perfect design implementation.",
      servicesList: [
        "Professional business websites",
        "Portfolio & company profile websites",
        "Responsive frontend development (HTML, CSS, JS)",
        "Landing pages & custom layouts",
      ],
    },
    {
      id: 3,
      title: "Full-Stack Development",
      category: "web",
      description:
        "Our website development services cover everything from simple business websites to dynamic, scalable platforms.",
      longDescription:
        "Each project is built with a strong emphasis on speed, security, SEO, and a smooth user experience.",
      servicesList: [
        "Backend development (Node.js, PHP, Laravel, etc.)",
        "API development & integrations",
        "Database design & management",
        "Complete web application architecture",
      ],
    },
    {
      id: 4,
      title: "Mobile App Development",
      category: "web",
      description:
        "We develop high-quality mobile applications for both Android and iOS platforms.",
      longDescription:
        "Whether it's an e-commerce app, service app, or custom tool, we transform ideas into powerful mobile experiences.",
      servicesList: [
        "Android & iOS apps",
        "Cross-platform applications",
        "UI/UX for mobile apps",
        "App optimization & maintenance",
      ],
    },
    {
      id: 5,
      title: "Motion Graphics & Animation",
      category: "animation",
      description:
        "We create engaging motion graphics and animations that bring your brand to life.",
      longDescription:
        "From explainer videos to promotional animations, we deliver visual content that captures attention and communicates your message effectively.",
      servicesList: [
        "2D promotional videos",
        "Explainer animations",
        "Logo animations",
        "Product animations",
      ],
    },
    {
      id: 6,
      title: "SEO Services",
      category: "seo",
      description:
        "Our SEO services are designed to improve your search engine ranking, increase organic traffic, and strengthen your digital presence.",
      longDescription:
        "We implement on-page optimization, keyword research, technical SEO, content improvement, website audits, link strategies, and performance enhancements—ensuring long-term visibility and measurable results.",
      servicesList: [
        "On-page SEO",
        "Technical SEO audits",
        "Keyword optimization",
        "Search visibility & ranking improvement",
      ],
    },
    {
      id: 7,
      title: "Digital Marketing",
      category: "marketing",
      description:
        "We provide complete digital marketing services that help businesses grow online.",
      longDescription:
        "From campaign strategy and audience analysis to social media management and paid ads, we create data-backed marketing systems focused on reach, engagement, and conversions.",
      servicesList: [
        "Social media marketing",
        "Paid advertising campaigns",
        "Content strategy",
        "Brand awareness & engagement",
      ],
    },
    {
      id: 8,
      title: "Marketing Visuals & Creative Assets",
      category: "graphic",
      description:
        "We specialize in providing premium marketing visuals for businesses, including product images, promotional graphics, and enhanced visual assets.",
      longDescription:
        "Our team also transforms low-quality or poor-resolution pictures into clean, crisp, and high-resolution visuals suitable for digital ads, catalogs, e-commerce, and social media.",
      servicesList: [
        "Product editing & high-resolution enhancements",
        "Creative assets for ads and campaigns",
        "Cross-department design support",
      ],
    },
  ];

  // Split into rows of 3 — each row is its own flex container so
  // expanding one card never disturbs its siblings
  const rows = [];
  for (let i = 0; i < services.length; i += 3) {
    rows.push(services.slice(i, i + 3));
  }

  return (
    <div className="service-section padding-container">
      <div className="page-cover">
        <div className="service">

          {/* Heading */}
          <div className="service-heading">
            <h1>
              OUR <span className="orange-text">SERVICES</span>
            </h1>
          </div>

          {/* Introduction Paragraph */}
          <div className="service-introduction">
            <p>
              At VisionBird Technologies, we provide a comprehensive suite of digital, creative,
              and technology-driven services designed to empower businesses worldwide. Our team
              blends innovation, strategy, and technical expertise to deliver solutions that
              enhance brand identity, strengthen digital presence, and accelerate business growth.
              Each service is crafted with a focus on quality, user experience, and long-term value.
            </p>
          </div>

          {/* Services — row by row so expanding one card never disturbs its siblings */}
          <div className="services-rows-wrapper">
            {rows.map((rowServices, rowIndex) => (
              <div key={rowIndex} className="services-row">
                {rowServices.map((service) => {
                  const index = service.id;
                  const isOpen = expandedStates[index];
                  return (
                    <div key={service.id} className="service-box">
                      <div className="service-content-wrapper">
                        <div className="service-main-content">
                          <div className="service-icon">
                            {getIconForService(service.id)}
                          </div>

                          <div className="service-text">
                            <h1>{service.title}</h1>

                            {/* First paragraph — always visible */}
                            <p className="first-description">{service.description}</p>

                            {/* Preview / expanded long description */}
                            {isOpen ? (
                              <p className="second-description">{service.longDescription}</p>
                            ) : (
                              <div className="blurry-preview">
                                <p className="blurry-text">{getFirstSentence(service.longDescription)}</p>
                              </div>
                            )}

                            {/* Services list — only when expanded */}
                            {isOpen && (
                              <>
                                <h3 className="services-include-heading">Our Services Include:</h3>
                                <div className="service-option">
                                  {service.servicesList.map((item, idx) => (
                                    <div key={idx} className="responsibility">
                                      <FaCube className="cube-icons" />
                                      <p>{item}</p>
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {/* Read More Button */}
                        <div className="read-more-container">
                          <button
                            className="cta-btn"
                            style={{ color: "white" }}
                            onClick={() => toggleExpanded(index)}
                          >
                            <span>{isOpen ? "SHOW LESS" : "READ MORE..."}</span>
                            <span className="arrow-icon">
                              {isOpen ? "▲" : "▼"}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          {/* Footer spacing */}
          <div
            className="all-service-btn"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
              marginBottom: "50px",
            }}
          ></div>
        </div>
      </div>

      <style>{`
    /* ── Introduction ── */
    .service-introduction {
      text-align: center;
      max-width: 900px;
      margin: 0 auto 50px;
      font-size: 18px;
      line-height: 1.6;
      color: #333;
    }

    /* ── Typography inside cards ── */
    .first-description {
      margin-bottom: 15px;
    }

    .second-description {
      margin-bottom: 20px;
    }

    /* ── Blurry preview — desktop: fixed height blur teaser ── */
    .blurry-preview {
      position: relative;
      overflow: hidden;
      margin-bottom: 15px;
      height: 55px;
    }

    .blurry-text {
      filter: blur(2px);
      opacity: 0.8;
      margin: 0;
      user-select: none;
      font-size: 16px;
      line-height: 1.5;
      color: #666;
    }

    /* ── Expanded list ── */
    .services-include-heading {
      margin-top: 20px;
      margin-bottom: 15px;
      color: #333;
      font-size: 18px;
    }

    .service-option {
      margin-bottom: 20px;
    }

    .responsibility {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;
    }

    .cube-icons {
      color: #ff6b00;
      margin-right: 10px;
      margin-top: 3px;
      flex-shrink: 0;
    }

    .responsibility p {
      margin: 0;
      line-height: 1.5;
    }

    /* ── Button ── */
    .read-more-container {
      margin-top: 20px;
    }

    .arrow-icon {
      font-size: 12px;
    }

    /* ── Row-based layout: each row is its own flex container ──
       align-items: flex-start means every card is only as tall
       as its own content — expanding one never stretches siblings.
    ── */
    .services-rows-wrapper {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }

    .services-row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 30px;
    }

    .services-row .service-box {
      flex: 1 1 0;
      min-width: 0;
      align-self: flex-start;
    }

    /* ── Tablet: 2 columns ── */
    @media (max-width: 900px) {
      .services-row {
        flex-wrap: wrap;
        gap: 20px;
      }
      .services-row .service-box {
        flex: 1 1 calc(50% - 10px);
        max-width: calc(50% - 10px);
      }
    }

    /* ── Mobile: single column, tight spacing ── */
    @media (max-width: 560px) {
      .services-rows-wrapper {
        gap: 16px;
      }

      .services-row {
        flex-direction: column;
        gap: 16px;
      }

      .services-row .service-box {
        flex: 1 1 100%;
        max-width: 100%;
      }

      /* Tighten intro paragraph */
      .service-introduction {
        font-size: 15px;
        margin-bottom: 28px;
      }

      /* On mobile replace the fixed-height blur box with a clean
         fade-out teaser — no dead whitespace, text hugs its content */
      .blurry-preview {
        height: auto;
        max-height: 44px;
        margin-bottom: 10px;
        -webkit-mask-image: linear-gradient(to bottom, black 40%, transparent 100%);
        mask-image: linear-gradient(to bottom, black 40%, transparent 100%);
      }

      .blurry-text {
        filter: none;
        opacity: 1;
        font-size: 14px;
        color: #888;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      /* Tighten card internals */
      .first-description {
        font-size: 14px;
        margin-bottom: 10px;
      }

      .second-description {
        font-size: 14px;
        margin-bottom: 14px;
      }

      .services-include-heading {
        font-size: 15px;
        margin-top: 14px;
        margin-bottom: 10px;
      }

      .service-option {
        margin-bottom: 12px;
      }

      .responsibility {
        margin-bottom: 7px;
      }

      .responsibility p {
        font-size: 14px;
      }

      .read-more-container {
        margin-top: 12px;
      }
    }
      `}</style>
    </div>
  );
};

export default OurServices;